import React from 'react';
import { Layout, Row, Col } from 'antd';
import InfoBtn from '../../../asset/globus-logo.svg';
import { ReactComponent as Mastercard } from '../../../asset/svg/paymentCardType/mastercard.svg';

const items = [
  {
    name: 'noxtton.com',
    price: '$7.99',
    privacy: 'Privacy: OFF',
    renew: 'Auto Renew: ON',
    term: '1 Year'
  },
  {
    name: 'noxtton.com',
    price: '$7.99',
    privacy: 'Privacy: OFF',
    renew: 'Auto Renew: ON',
    term: '1 Year'
  },
  {
    name: 'noxtton.com',
    price: '$7.99',
    privacy: 'Privacy: OFF',
    renew: 'Auto Renew: ON',
    term: '1 Year'
  }
];

const OverviewPage = () => {
  return (
    <Layout
      style={{
        backgroundColor: '#F0F4FF',
        borderRadius: '10px',
        height: '560px',
        marginLeft: '34px',
        width: '744px'
      }}
    >
      <Row style={{ fontWeight: 'bold', margin: '30px', marginTop: '24px' }}>
        {items.length} items
      </Row>
      {items.map((i, index) => {
        return (
          <Row
            key={index}
            style={{
              justifyContent: 'space-between',
              marginLeft: '30px',
              marginRight: '30px',
              paddingBottom: '20px'
            }}
          >
            <Col style={{ fontWeight: 'bold' }}>
              <img alt="information" src={InfoBtn} style={{ paddingRight: '18px' }} />
              {i.name}
            </Col>
            <Col>{i.term}</Col>
            <Col>{i.renew}</Col>
            <Col>{i.privacy}</Col>
            <Col>
              <b>{i.price}</b>/mo
            </Col>
          </Row>
        );
      })}

      <hr
        style={{
          border: '1px solid #CAD8FF',
          width: '95%'
        }}
      />

      <Row style={{ fontWeight: 'bold', margin: '30px' }}>Payment Method</Row>

      <Row
        style={{
          height: '86px',
          marginBottom: '30px',
          marginLeft: '30px',
          width: '340px'
        }}
      >
        <Layout
          style={{
            backgroundColor: 'white',
            border: '1px solid #CAD8FF',
            borderRadius: '10px',
            boxSizing: 'border-box'
          }}
        >
          <Row>
            <Col style={{ marginLeft: '24px', marginTop: '28px' }}>
              <Mastercard />
            </Col>
            <Col style={{ marginLeft: '16px', marginTop: '24px' }}>
              <Row style={{ fontWeight: 'bold' }}>BOG</Row>
              <Row>08/22</Row>
            </Col>
            <Col
              style={{
                fontWeight: 'bold',
                marginLeft: '112px',
                marginTop: '24px'
              }}
            >
              **** 3901
            </Col>
          </Row>
        </Layout>
      </Row>

      <hr
        style={{
          border: '1px solid #CAD8FF',
          width: '95%'
        }}
      />

      <Row
        style={{
          fontWeight: 'bold',
          marginBottom: '10px',
          marginLeft: '30px',
          marginTop: '30px'
        }}
      >
        Billing Information
      </Row>

      <Row style={{ fontSize: '12px', marginLeft: '30px' }}>
        32 Abashidze Street, 0160; Tbilisi, GE
      </Row>
      <Row style={{ fontSize: '12px', marginLeft: '30px' }}>+ 0 322 90 10 10</Row>
      <Row style={{ fontSize: '12px', marginLeft: '30px' }}>mail@gmail.com</Row>
    </Layout>
  );
};

export default OverviewPage;
